export const ChatTitle = (chatData, currentUser) => {
  return chatData.isGroup
    ? chatData.chatName
    : chatData.members[0]?._id === currentUser?.id
    ? chatData.members[1].name
    : chatData.members[0].name;
};

export const ChatDescription = (chatData, currentUser) => {
  return chatData.isGroup
    ? chatData.about
    : chatData.members[0]?._id === currentUser?.id
    ? chatData.members[1].email
    : chatData.members[0].email;
};

export const IsGroupAdmin = (chatData, currentUser) => {
  return chatData.isGroup && chatData.admin._id === currentUser?.id;
};

export const setLsCurrentChat = (chatData) => {
  const chatObj = {
    name: chatData.chatName,
    _id: chatData._id,
    isGroup: chatData.isGroup,
    members: chatData.members,
  };
  localStorage.setItem("vv-current-chat", JSON.stringify(chatObj));
};

export const getReceiverName = () => {
  let currentUser;
  let currentChat;
  const storedUser = localStorage.getItem("current-user");
  if (storedUser && JSON.parse(storedUser)) {
    currentUser = JSON.parse(storedUser);
  }
  const storedChat = localStorage.getItem("vv-current-chat");
  if (storedChat && JSON.parse(storedChat)) {
    currentChat = JSON.parse(storedChat);
  }

  if (currentChat?._id) {
    return currentChat.isGroup
      ? currentChat.name
      : currentChat.members[0]?._id === currentUser?.id
      ? currentChat.members[1].name
      : currentChat.members[0].name;
  } else {
    return "Other User";
  }
};

export const getReceiverIds = () => {
  let currentUser;
  let currentChat;
  const storedUser = localStorage.getItem("current-user");
  if (storedUser && JSON.parse(storedUser)) {
    currentUser = JSON.parse(storedUser);
  }
  const storedChat = localStorage.getItem("vv-current-chat");
  if (storedChat && JSON.parse(storedChat)) {
    currentChat = JSON.parse(storedChat);
  }

  if (currentChat?._id) {
    return currentChat.members
      .filter((member) => member._id !== currentUser?.id)
      .map((member) => member._id);
  } else {
    return [];
  }
};
